"use client"

import * as React from "react"
import {
  Carousel,
  CarouselContent,
  CarouselItem, 
  CarouselNext,
  CarouselPrevious,
} from "@/shared/components/ui/carousel"
import { Star } from "lucide-react"
import { useTranslations } from "next-intl"
import { SectionHeader } from "@/shared/components/home"


export function Testimonials() {
  const t = useTranslations("testimonials");
  const testimonials = [
    {
      quote:
        "Lorem ipsum dolor sit amet consectetur. Ut duis felis vitae lectus amet vel enim et. Ultrices neque ac nibh neque id dui semper mattis.",
      name: "Company name",
      rating: 4,
    },
    {
      quote:
        "Lorem ipsum dolor sit amet consectetur. Ut duis felis vitae lectus amet vel enim et. Ultrices neque ac nibh neque id dui semper mattis.",
      name: "Company name",
      rating: 5,
    },
    {
      quote:
        "Lorem ipsum dolor sit amet consectetur. Ut duis felis vitae lectus amet vel enim et. Ultrices neque ac nibh neque id dui semper mattis.",
      name: "Company name",
      rating: 4,
    },
    {
      quote:
        "Lorem ipsum dolor sit amet consectetur. Ut duis felis vitae lectus amet vel enim et. Ultrices neque ac nibh neque id dui semper mattis.",
      name: "Another Company",
      rating: 5,
    },
    {
      quote:
        "Lorem ipsum dolor sit amet consectetur. Ut duis felis vitae lectus amet vel enim et. Ultrices neque ac nibh neque id dui semper mattis.",
      name: "Another Company",
      rating: 5,
    },
  ]
  
  // Helper function to group testimonials
  const groupTestimonials = (data: typeof testimonials, size: number) => {
    const grouped = []
    for (let i = 0; i < data.length; i += size) {
      grouped.push(data.slice(i, i + size))
    }
    return grouped
  }
  
  function StarRating({ rating }: { rating: number }) {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <Star
          key={i}
          className={`w-5 h-5 ${
            i <= rating ? "fill-brand-accent-text text-brand-accent-text" : "text-brand-accent-text"
          }`}
        />
      )
    }
    return <div className="flex gap-1">{stars}</div>
  }
  const groupedData = groupTestimonials(testimonials, 3)

  return (
    <section className="home-dotgrid scroll-mt-20 bg-home-cream-2 py-24 md:scroll-mt-20" id="testimonials">
      <div className="container">
        <SectionHeader
          animated
          align="start"
          className="mb-10"
          eyebrow={t("subtitle")}
          title={t("title")}
          highlight={t("highlight")}
        />

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full max-w-4xl mx-auto"
        >
          <CarouselContent>
            {groupedData.map((group, groupIndex) => (
              <CarouselItem key={groupIndex}>
                <div className="flex flex-col gap-6 p-1"> 
                  {group.map((testimonial, itemIndex) => {
                    const backgroundStyle = itemIndex % 2 === 0 
                      ? { background: 'linear-gradient(90deg, var(--brand-sand) 0%, var(--brand-cream) 100%)' }
                      : { background: 'linear-gradient(270deg, var(--brand-sand) 0%, var(--brand-cream) 100%)' };

                    return (
                      <div
                        key={itemIndex}
                        className="p-8 rounded-lg space-y-4 flex flex-col justify-center items-center"
                        style={backgroundStyle}
                      >
                        <StarRating rating={testimonial.rating} />
                        <p className="text-lg font-medium text-brand-navy">
                          {testimonial.name}
                        </p>
                        <blockquote className="text-brand-muted-light italic text-center">
                          “{testimonial.quote}”
                        </blockquote>
                      </div>
                    );
                  })}
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-4 mt-8">
            <CarouselPrevious className="static translate-y-0 bg-brand-cream text-brand-navy hover:bg-brand-sand hover:text-brand-navy focus-visible:ring-brand-navy focus-visible:ring-offset-brand-cream" />
            <CarouselNext className="static translate-y-0 bg-brand-cream text-brand-navy hover:bg-brand-sand hover:text-brand-navy focus-visible:ring-brand-navy focus-visible:ring-offset-brand-cream" />
          </div>
        </Carousel>
      </div>
    </section>
  )
}
